import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { from, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Archivo } from '../core.models/archivo';
import { ArchivoCliente } from '../core.models/archivoCliente';

@Injectable({
    providedIn: 'root',
})
export class FileApiService {
    private secretKey = environment.tokenSecret;

    constructor(private http: HttpClient) { }

    uploadFileCliente(formData: FormData, clienteId: number, carpeta?: string) {
        if (carpeta) {
            formData.append('carpeta', carpeta);
        }
        formData.append('clienteId', clienteId.toString());

        return from(this.generateRequestToken(formData)).pipe(
            switchMap((token) => {
                const headers = new HttpHeaders({
                    Authorization: `Bearer ${token}`,
                });

                return this.http.post<ArchivoCliente>(environment.apiUrl + '/files/uploadFileCliente', formData, { headers });
            })
        );
    }

    uploadFile(formData: FormData, carpeta?: string) {
        if (carpeta) {
            formData.append('carpeta', carpeta);
        }

        return from(this.generateRequestToken(formData)).pipe(
            switchMap((token) => {
                const headers = new HttpHeaders({
                    Authorization: `Bearer ${token}`,
                });

                return this.http.post<Archivo>(environment.apiUrl + '/files/uploadFile', formData, { headers });
            })
        );
    }

    private async generateRequestToken(formData: FormData): Promise<string> {
        const secretKey = this.secretKey;

        const formDataObj: any = {};

        const filePromises: Promise<void>[] = [];
        formData.forEach((value, key) => {
            if (key === 'file' && value instanceof File) {
                const promise = this.calculateFileHash(value).then((fileHash) => {
                    formDataObj['fileHash'] = fileHash;
                });
                filePromises.push(promise);
            } else {
                formDataObj[key] = value;
            }
        });

        await Promise.all(filePromises);

        const dataString = JSON.stringify(formDataObj);

        const checksum = CryptoJS.HmacSHA256(dataString, secretKey).toString(CryptoJS.enc.Hex);

        const payload = {
            checksum: checksum,
            timestamp: Date.now(),
        };

        const header = {
            alg: "HS256",
            typ: "JWT",
        };

        const encodedHeader = CryptoJS.enc.Base64url.stringify(
            CryptoJS.enc.Utf8.parse(JSON.stringify(header))
        );
        const encodedPayload = CryptoJS.enc.Base64url.stringify(
            CryptoJS.enc.Utf8.parse(JSON.stringify(payload))
        );
        const signature = CryptoJS.HmacSHA256(`${encodedHeader}.${encodedPayload}`, secretKey);
        const encodedSignature = CryptoJS.enc.Base64url.stringify(signature);

        return `${encodedHeader}.${encodedPayload}.${encodedSignature}`;
    }

    private async calculateFileHash(file: File): Promise<string> {
        const arrayBuffer = await file.arrayBuffer();

        const wordArray = CryptoJS.lib.WordArray.create(new Uint8Array(arrayBuffer));

        return CryptoJS.SHA256(wordArray).toString(CryptoJS.enc.Hex);
    }

}
